import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { createStructuredSelector } from 'reselect';
import { closeModal, upgradeExtraLicensePlan } from './actions';
import ExtraLicenseRegisterForm from './ExtraLicenseRegisterForm';
import { makeSelectElPlans, makeSelectModal } from './selectors';
import Config from '~/config';
import withI18next from '~/../hocs/_withI18next';

@withI18next()
class ExtraLicenseModalContainer extends React.Component {
  handleClose = () => {
    this.props.closeModal();
  };

  registerExtraLicense = (results) => {
    if (!results.selected_plan) {
      return toast.warning(this.props.t('select_plan_required'));
    }
    const { upgradeExtraLicensePlan, el_plans, lng } = this.props;
    const selectedPlan = el_plans.filter(
      (item) => item.id == results.selected_plan,
    )[0];
    upgradeExtraLicensePlan({
      currency: selectedPlan.prices.filter((item) => item.lang == lng)[0].unit,
      packId: selectedPlan.id,
      lang: lng,
    });
  };

  render() {
    const { modal, t, lng, el_plans } = this.props;
    return (
      <Modal
        show={modal}
        onHide={this.handleClose}
        className="modal-register-extra-license-container"
      >
        <Modal.Body
          className={`modal-register-extra-license bg-gradient-color-${Config.serviceType}`}
        >
          <ExtraLicenseRegisterForm
            onSubmit={this.registerExtraLicense}
            el_plans={el_plans}
          />
        </Modal.Body>
        <style jsx global>
          {`
            .modal-register-extra-license-container .modal-dialog {
              width: 950px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .bg-gradient-color-illust_ac {
              background: repeating-linear-gradient(
                #d73a4e,
                #d73a4e 40.9%,
                #f9f9f9 40.1%,
                #f9f9f9 100%
              );
            }
            .modal-register-extra-license-container
              .modal-dialog
              .bg-gradient-color-photo_ac {
              background: repeating-linear-gradient(
                #509bdc,
                #509bdc 40.9%,
                #f9f9f9 40.1%,
                #f9f9f9 100%
              );
            }
            .modal-register-extra-license-container
              .modal-dialog
              .bg-gradient-color-silhouette_ac {
              background: repeating-linear-gradient(
                #41b9b8,
                #41b9b8 40.9%,
                #f9f9f9 40.1%,
                #f9f9f9 100%
              );
            }
            .modal-register-extra-license-container
              .modal-dialog
              .bg-gradient-color-design_ac {
              background: repeating-linear-gradient(
                #ffa823,
                #ffa823 40.9%,
                #f9f9f9 40.1%,
                #f9f9f9 100%
              );
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .header {
              width: 100%;
              max-width: 560px;
              margin-bottom: 35px;
              text-align: center;
              color: #fff;
              font-family: 'Open Sans', sans-serif;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .header
              .header__title {
              font-size: 32px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .header
              .header__text {
              color: #f2f3f4;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans {
              display: flex;
              align-items: center;
              flex-flow: row wrap;
              justify-content: space-around;
              width: 100%;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button {
              display: flex;
              flex-direction: column;
              align-items: center;
              font-family: Roboto, sans-serif;
              width: 265px;
              margin: 5px 0;
              padding: 0;
              border-radius: 2px;
              background: white;
              box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.3);
              transition: transform 0.5s;
              cursor: pointer;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription_button_select {
              display: block;
              text-align: center;
              padding: 10px;
              width: 80%;
              border-radius: 2px;
              margin-bottom: 25px;
              transition: 0.5s;
              color: #fff;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription_button_select.illust_ac {
              border: solid 2px #d73a4e;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription_button_select.photo_ac {
              border: solid 2px #509bdc;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription_button_select.silhouette_ac {
              border: solid 2px #41b9b8;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription_button_select.design_ac {
              border: solid 2px #ffa823;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__title,
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__price {
              text-transform: uppercase;
              margin-top: 0;
              margin-bottom: 0;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__title {
              display: flex;
              flex-direction: column;
              align-items: center;
              padding: 10px;
              margin-top: 20px;
              font-size: 20px;
              width: 100%;
              border-top-left-radius: 10px;
              border-top-right-radius: 10px;
              font-weight: bold;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__title.photo_ac {
              color: #509bdc;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__title.illust_ac {
              color: #d73a4e;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__title.silhouette_ac {
              color: #41b9b8;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__title.design_ac {
              color: #ffa823;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__price {
              display: block;
              width: 90%;
              text-align: center;
              text-transform: lowercase;
              font-size: 16px;
              color: #1b2833;
              padding-bottom: 10px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              .subscription__button
              .subscription__price
              .subscription__price-month {
              font-size: 18px;
              color: #3e3e3f;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio'] {
              display: none;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:hover
              + label {
              background: white;
              transform: scale(1.09);
              transition: transform 0.5s;
              box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.65);
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label {
              background: white;
              transform: scale(1.09);
              transition: transform 0.5s;
              box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.65);
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label
              .selected-icon {
              display: block;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label
              .subscription_button_select {
              color: white;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label
              .subscription_button_select.photo_ac {
              background: #509bdc;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label
              .subscription_button_select.illust_ac {
              background: #d73a4e;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label
              .subscription_button_select.silhouette_ac {
              background: #41b9b8;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-plans
              input[type='radio']:checked
              + label
              .subscription_button_select.design_ac {
              background: #ffa823;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-merit {
              margin-top: 30px;
              font-size: 16px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-merit
              .extra-license-merit-title {
              font-size: 20px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-merit
              .subscription__list {
              padding: 0 15px;
              margin: 10px 0;
              margin-left: 80px;
              list-style-type: none;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-merit
              .subscription__list
              .subscription__item {
              display: flex;
              margin: 20px 0;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-merit
              .subscription__list
              .subscription__item
              .icon-subscription {
              margin-right: 5px;
              color: green;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-sub-button {
              margin-top: 25px;
              margin-bottom: 25px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-sub-button
              button {
              padding: 15px 20px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-term {
              text-align: center;
              margin-top: 20px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-register-term {
              margin-bottom: 25px;
            }
            .modal-register-extra-license-container
              .modal-dialog
              .extra-license-register-form
              .extra-license-register-term
              p {
              font-style: italic;
            }
          `}
        </style>
      </Modal>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  modal: makeSelectModal(),
  el_plans: makeSelectElPlans(),
});
const mapDispatchToProps = (dispatch) => ({
  upgradeExtraLicensePlan: (params) =>
    dispatch(upgradeExtraLicensePlan(params)),
  closeModal: () => dispatch(closeModal()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExtraLicenseModalContainer);
